import { ERoutePaths } from "@gift/types";
import { Route } from "react-router-dom";
import { Page_ContactUs } from "./ContactUs";

export default [
    <Route path={ERoutePaths.CONTACT_US} element={<Page_ContactUs />} />,
];
